import type { ColorGroups } from './backgroundColorGroups';
import { borderColorGroups } from './borderColorGroups';

/**
 * outline color groups mirror borderColorGroups but use `outline-*` prefixed ids so
 * the theme-manager style resolver emits the picked value under `outline-color`
 * instead of `border-color`. the underlying CSS variable (`color.value`) is reused,
 * so the swatch palette stays in sync with the border palette without duplication.
 *
 * tailwind's outlineColor plugin is disabled in packages/style/tailwind.config.cjs,
 * so these ids have no CSSOM-resolvable utility class — theme-manager falls through
 * to the configured-value cache, which maps each id to its `var(--...)` reference.
 */
export const outlineColorGroups: ColorGroups[] = borderColorGroups.map((group) => ({
  ...group,
  id: 'outlineColor',
  colors: group.colors.map((color) => ({
    ...color,
    id: color.id.replace(/^border-/, 'outline-'),
  })),
}));
